<div class="padding">
  <form [formGroup]="lienDetails">
    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$"
    [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" type="number" [formControlName]="'amount'">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showMaturityDate) {
      <div class="flex-container padding-top">
        <div class="flex-item form-field">
          <mat-radio-group formControlName="maturityDateOptions" name="maturity-date-selection"
            [attr.aria-label]="'orders.lienMaturityDateOrNoMaturity' | transloco">
            <mat-radio-button class="radio-button" data-testid="no-fixed-maturity-date-radio-button"
              [value]="noFixedMaturityDate">{{ 'orders.noFixedMaturityDate' | transloco }}</mat-radio-button>
            <mat-radio-button class="radio-button" data-testid="maturity-date-radio-button"
              [value]="maturityDate">{{ 'orders.maturityDate' | transloco }}</mat-radio-button>
            <mat-radio-button class="radio-button" data-testid="no-maturity-date-radio-button"
            [value]="noMaturityDateInformation">{{ 'orders.noMaturityDateInformationProvided' | transloco }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    }

    @if (showMaturityDate()) {
      <div class="flex-container padding-top">
        <mat-form-field class="form-field flex-item" appearance="outline">
          <mat-label>{{ 'orders.maturityDate' | transloco }}</mat-label>
          <input matInput [matDatepicker]="maturityDate" data-testid="maturity-date-field" [placeholder]="'orders.maturityDate' | transloco"
            [formControlName]="'maturityDate'">
          <mat-datepicker-toggle matSuffix [for]="maturityDate"></mat-datepicker-toggle>
          <mat-datepicker #maturityDate></mat-datepicker>
        </mat-form-field>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showCautionFiling) {
      <div
        class="flex-container flex-item padding-top">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" [formControlName]="'cautionFiling'" data-testid="caution-filing-checkbox">
            {{ 'orders.cautionFiling' | transloco }}
          </mat-checkbox>
          <lib-error-bubble [control]="lienDetails.controls['cautionFiling']"
          [message]="cautionFilingError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
</div>